// External link open in new tab
document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll(
        '.menu-list li a, .custom-footer__nav a'
    );

    links.forEach(link => {
        const href = link.getAttribute('href');

        if(
            href &&
            href.startsWith('http') &&
            !href.includes(window.location.hostname)
        ){
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });
});